import { InsightsDashboardPoolState } from '@aytm/app/insights/dashboard/duckness/ducks/types'
import { MethodListModel } from '@aytm/app/insights/dashboard/models/BlockModel.models'
import { getCurrentBlock, updateCurrentBlock } from './requests'
import type { GroupListModel } from '@aytm/app/insights/dashboard/models/types.ClientModel'

export type ChartScaleChangePayload = {
  scale: string
}

export type ChartTypeChangePayload = {
  type: string
}

export type LegendClickPayload = {
  section: string
  attribute: string
  method: string
}

/**
 * Change data chart scale
 */
export const chartScaleChange = (state: InsightsDashboardPoolState, { scale }: ChartScaleChangePayload) => {
  const block = getCurrentBlock(state)
  const currentSplit = block?.get<string>('currentSplit') || null
  return currentSplit
    ? updateCurrentBlock(state, { blockChartScale: scale })
    : updateCurrentBlock(state, { dataChartScale: scale })
}

/**
 * Change data chart scale
 */
export const chartTypeChange = (state: InsightsDashboardPoolState, { type }: ChartTypeChangePayload) => {
  const block = getCurrentBlock(state)
  const currentSplit = block?.get<string>('currentSplit') || null
  const chartScale =
    ('stackedArea' === type
      ? 'min-max'
      : currentSplit
      ? block?.get<string>('blockChartScale')
      : block?.get<string>('dataChartScale')) || 'min-max'
  return currentSplit
    ? updateCurrentBlock(state, { blockChartType: type, blockChartScale: chartScale })
    : updateCurrentBlock(state, { dataChartType: type, dataChartScale: chartScale })
}

/**
 * Legend click event - toggles method disabled/enabled state
 */
export const legendClick = (state: InsightsDashboardPoolState, { section, attribute, method }: LegendClickPayload) => {
  let resultState = state
  const block = getCurrentBlock(state)
  const sections = block?.getSections()
  const sectionIndex = sections.findIndex(s => section === s.get('name'))
  if (sectionIndex >= 0) {
    const newSections = sections.updateIn([sectionIndex, 'metrics', attribute, 'disabled'], (disabled: string[]) => {
      if (disabled) {
        return disabled.includes(method) ? disabled.filter(v => v !== method) : disabled.push(method)
      } else {
        return MethodListModel([method]) as string[]
      }
    }) as unknown as GroupListModel
    resultState = updateCurrentBlock(state, { sections: newSections })
  }
  return resultState
}
